export default __webpack_public_path__ + "static/media/logo-jira.2883b459.svg";